import React, { createContext, useContext, useState } from 'react';

// Création du contexte pour le nom d'affichage
const DisplayNameContext = createContext();

// Fournisseur de contexte pour le nom d'affichage
export const DisplayNameProvider = ({ children }) => {
  const [displayName, setDisplayName] = useState('');

  return (
    <DisplayNameContext.Provider value={{ displayName, setDisplayName }}>
      {children}
    </DisplayNameContext.Provider>
  );
};

// Hook personnalisé pour accéder au nom d'affichage et à sa fonction de mise à jour
export const useDisplayName = () => {
  return useContext(DisplayNameContext);
};
